// Public actions, to be called by React components.
import {createAction} from 'typesafe-actions';

import * as Types from './types';

export const set = createAction(
  '@viewer/set',
  action => (viewer?: Types.Viewer) => action({viewer})
);
